
import Logo from "../../images/logo.png"
import SliderOneImage from "../../images/wwph_img_two.jpeg"
import HeroImg from "../../images/heroimg.png"
import boy1 from "../../images/boy_one.png"
import SliderTwoImage from "../../images/wwph_img_two.jpeg"
import SliderThreeImage from "../../images/wwph_img_one.jpeg"
import SliderFourImage from "../../images/wwph_img_six.png"
import SliderFiveImage from "../../images/wwph_img_two.jpeg"
import SliderSixImage from "../../images/wwph_img_one.jpeg"
import OneStepImage from "../../images/wwph_img_six.png"
import RegisterImage from "../../images/register.svg"
import ApplyImage from "../../images/apply.svg"
import InterviewImage from "../../images/interview.svg"
import CongratulationImage from "../../images/congratulation.svg"
import PlatformCardImage from "../../images/Group 14.png"
import PerfectMatchImage from "../../images/wwph_img_three.jpeg"
import GoogleImage from "../../images/google.png"
import FacebookImage from "../../images/facebook.png"
import TwitterImage from "../../images/twitter.png"
import AppleImage from "../../images/apple.png"
import IBMImage from "../../images/ibm.png"
import FooterBg from "../../images/footerbg.png"
import SportifyImage from "../../images/spotify.png"
import MicrosoftImage from "../../images/microsoft.png"
import NetflixImage from "../../images/netflix.png"
import AmazonImage from "../../images/social.png"
import OracleImage from "../../images/oracle.png"
import UberImage from "../../images/uber.png"
import AddosserImage from "../../images/addosser.jpeg"
import UBAImage from "../../images/uba.png"
import FirstBankImage from "../../images/first-bank.png"
import AccessbankImage from "../../images/accessbank.svg"
import DiscoderImage from "../../images/discord.png"
import LinkedInImage from "../../images/linkedin.png"
import ThreadsImage from "../../images/threads.png"
import PaypalImage from "../../images/paypal.png"
import ChatGPTImage from "../../images/chat-gpt.png"
import SamsungImage from "../../images/samsung.png"
import SonyImage from "../../images/sony.png"
import ItelImage from "../../images/intel.png"
import TiktokImage from "../../images/tiktok.png"
import HuaweiImage from "../../images/huawei.png"
import ModernaImage from "../../images/moderna.png"
import TencentImage from "../../images/tencent.png"
import ZenithBankImage from "../../images/Zenith-Bank-logo.png"
import FidelityImage from "../../images/fidelity.png"
import SterlingBankImage from "../../images/sterling.png"
import StanbicImage from "../../images/stanbic-ibtc-logo.webp"
import MoniepointImage from "../../images/moniepoint.jpeg"
import CentrumImage from "../../images/centrum.png"
import PalmpayImage from "../../images/PalmPay.webp"
import RecruitImage from "../../images/recruit.png"
import EasilyImage from "../../images/wwph_img_one.jpeg"
import VideoImage from "../../images/wwph_img_six.png"
import SliderImageOne from "../../images/slider_one.png"
import SliderImageTwo from "../../images/slider_two.png"
import SliderImageThree from "../../images/slider_three.png"
import JoinUsImage from "../../images/wwph_img_three.jpeg"
import CareerSliderImageOne from "../../images/wwph_img_three.jpeg"
import CareerSliderImageTwo from "../../images/wwph_img_five.jpeg"
import CareerSliderImageThree from "../../images/wwph_img_one.jpeg"
import CareerCardImageFour from "../../images/career_five.png"
import CareerCardImageFive from "../../images/career_eleven.png"
import CareerCardImageSix from "../../images/career_twelve.png"
import CareerCardImageSeven from "../../images/workspace.jpg"
import CareerCardImageEight from "../../images/career_eight.png"
import CareerCardImageNine from "../../images/career_nine.png"
import CareerCardImageTen from "../../images/career_ten.png"
import CareerCardImageEleven from "../../images/career_eleven.png"
import CareerCardImageTwelve from "../../images/career_twelve.png"
import CareerCardImageThirteen from "../../images/career_thirteen.png"
import CareerCardImageFourteen from "../../images/career_fourteen.png"
import CareerCardImageFifteen from "../../images/Design_three.png"
import CareerImageTag from "../../images/career_three.png"
import OfficeSetting from "../../images/officeSetting.jpg"
import WorkSpace from "../../images/workspace.jpg"
import EditorMd from "../../images/editormd.jpg"
import SuccessMetric from "../../images/successMetric.jpg"
import SocialMedia from "../../images/socialmdia.jpg"
import AboutHeroImage from "../../images/wwph_img_three.jpeg"
import LoginImage from "../../images/wwph_img_four.jpeg"
import EmployerRegisterImage from "../../images/wwph_img_four.jpeg"
import JobSearchImage from "../../images/job-search.png"
import ProfileImage from "../../images/profile.png"
import delete_basket_y from "../../images/delete_basket_y.png";
import ProfileLogoOne from "../../images/Design 40 (1).png"
import ProfileLogoTwo from "../../images/Design 40 (2).png"
import ProfileLogoThree from "../../images/Design 40 (3).png"
import ProfileLogoFour from "../../images/Design 40 (4).png"
import ProfileLogoFive from "../../images/Design 40 (5).png"
import ProfileLogoSix from "../../images/Design 40 (6).png"
import ProfileLogoSeven from "../../images/Design 40 (7).png"
import ProfileLogoEight from "../../images/Design 40 (8).png"
import ProfileLogoNine from "../../images/Design 40 (9).png"
import ProfileLogoTen from "../../images/Design 40 (10).png"
import ProfileLogoEleven from "../../images/Design 40 (11).png"
import ProfileLogoTwelve from "../../images/Design 40 (12).png"
import ProfileLogoThirteen from "../../images/Design 40 (13).png"
import ProfileLogoForteen from "../../images/Design 40 (14).png"
import ProfileLogoFifteen from "../../images/Design 40 (15).png"
import ProfileLogoSixteen from "../../images/Design 40 (16).png"
import LeverageTestimonialLogo from "../../images/leverage-img.jpeg"
import CoraTestimonialLogo from "../../images/cora-img.jpeg"
import BluwayTestimonialLogo from "../../images/bluway-logo.jpeg"
import RedLenceTestimonialLogo from "../../images/rec-Lence-logo.jpeg"
import TheWomenTestimonialLogo from "../../images/the-women-img.jpeg"
import CollaborateAfricaTestimonialLogo from "../../images/collaborate-img.jpeg"
import LeveragePrintTestimonialLogo from "../../images/leverage_print-img.jpeg"
import Checklist from "../../images/checklist.png"
import CvBuilders from "../../images/cvBuilders.png"









interface Assets {
  [key: string]: string;
}

const assets: Assets = {
  Logo,
  boy1,
  HeroImg,
  SliderOneImage,
  SliderTwoImage,
  SliderThreeImage,
  SliderFourImage,
  SliderFiveImage,
  SliderSixImage,
  PerfectMatchImage,
  OneStepImage,
  RegisterImage,
  ApplyImage,
  InterviewImage,
  CongratulationImage,
  PlatformCardImage,
  GoogleImage,
  FacebookImage,
  TwitterImage,
  AppleImage,
  IBMImage,
  SportifyImage,
  MicrosoftImage,
  delete_basket_y,
  NetflixImage,
  AmazonImage,
  CareerImageTag,
  OracleImage,
  UberImage,
  AddosserImage,
  UBAImage,
  FooterBg,
  FirstBankImage,
  AccessbankImage,
  DiscoderImage,
  LinkedInImage,
  ThreadsImage,
  PaypalImage,
  ChatGPTImage,
  SamsungImage,
  SonyImage,
  ItelImage,
  TiktokImage,
  HuaweiImage,
  ModernaImage,
  TencentImage,
  ZenithBankImage,
  FidelityImage,
  SterlingBankImage,
  StanbicImage,
  MoniepointImage,
  CentrumImage,
  PalmpayImage,
  RecruitImage,
  EasilyImage,
  VideoImage,
  SliderImageOne,
  SliderImageTwo,
  SliderImageThree,
  JoinUsImage,
  CareerSliderImageOne,
  CareerSliderImageTwo,
  CareerSliderImageThree,
  CareerCardImageFour,
  CareerCardImageFive,
  CareerCardImageSix,
  CareerCardImageSeven,
  CareerCardImageEight,
  CareerCardImageNine,
  CareerCardImageTen,
  CareerCardImageEleven,
  CareerCardImageTwelve,
  CareerCardImageThirteen,
  CareerCardImageFourteen,
  CareerCardImageFifteen,
  WorkSpace,
  OfficeSetting,
  EditorMd,
  SuccessMetric,
  SocialMedia,
  AboutHeroImage,
  LoginImage,
  EmployerRegisterImage,
JobSearchImage,
Checklist,
CvBuilders,
ProfileImage,
ProfileLogoOne,
ProfileLogoTwo,
ProfileLogoThree,
ProfileLogoFour,
ProfileLogoFive,
ProfileLogoSix,
ProfileLogoSeven,
ProfileLogoEight,
ProfileLogoNine,
ProfileLogoTen,
ProfileLogoEleven,
ProfileLogoTwelve,
ProfileLogoThirteen,
ProfileLogoForteen,
ProfileLogoFifteen,
ProfileLogoSixteen,
LeverageTestimonialLogo,
CoraTestimonialLogo,
BluwayTestimonialLogo,
TheWomenTestimonialLogo,
RedLenceTestimonialLogo,
CollaborateAfricaTestimonialLogo,
LeveragePrintTestimonialLogo,
};

export default assets;

